import { message } from "antd";

const showSuccess = msg => {
    return message.success(msg);
}

export default showSuccess;